import React from 'react';

interface CardIconProps {
  className?: string;
  height?: number;
}

export const CardIcon: React.FC<CardIconProps> = ({ className, height = 40 }) => (
  <svg
    width={height * (106 / 78)}
    height={height}
    viewBox="0 0 106 78"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    role="img"
    aria-label="Carte bancaire"
  >
    <path
      d={
        'M106 18.0428V19.9098C105.198 21.2587 105.284 24.9234 104.573 26.0121' +
        'C104.457 26.1893 104.438 26.1367 104.247 26.1422L87.5689 22.7185' +
        'C87.1901 22.4526 87.4306 21.3474 87.367 20.846C86.9025 17.1924 ' +
        '84.8703 15.5886 81.2731 15.3393C71.7506 14.68 61.4816 15.8517 ' +
        '51.879 15.3448L21.553 9.12619C22.8055 6.29803 21.8406 -0.250223 ' +
        '26.2092 0.00738604L103.559 16.0318C104.806 16.2091 105.378 ' +
        '17.0761 106 18.0456V18.0428Z'
      }
      fill="#8D8D8D"
    />
    <path
      d={
        'M87.3726 36.7042L101.814 39.7013L94.7771 73.2542C94.2739 73.9993 ' +
        '93.378 74.8054 92.438 74.8691C91.1827 74.9522 88.5753 74.1489 ' +
        '87.3698 73.714V36.7042H87.3726Z'
      }
      fill="#8D8D8D"
    />
    <path
      d={
        'M87.3726 25.3002L103.929 28.6186C104.283 28.9704 102.345 35.8123 ' +
        '102.48 36.912L87.3726 34.214V25.2974V25.3002Z'
      }
      fill="#8D8D8D"
    />
    <path d="M20.3143 15.3476L20.9364 11.8242L21.2461 11.8131L38.3224 15.3476H20.3143Z" fill="#8D8D8D" />
    <path
      d={
        'M2.2537 18.0899L82.6196 18.1397C83.7311 18.6217 84.721 19.5192 ' +
        '84.6906 20.8322V75.1711C84.6712 76.3566 84.0049 77.279 ' +
        '82.968 77.7998C56.0015 78.0851 28.9078 78.0408 1.9302 77.8219' +
        'C1.1256 77.5366 0.544963 77.0131 0.229759 76.2098' +
        'C-0.234752 57.8005 0.17446 39.2858 0.0251529 20.8349' +
        'C-0.00249657 19.4721 1.07583 18.522 2.2537 18.0926V18.0899' +
        'ZM55.501 23.0205V26.9594H57.984V23.0205H55.501ZM60.8816 23.0205' +
        'V26.9594H63.5719V23.0205H60.8816ZM67.2963 23.0205V26.9594' +
        'H69.9866V23.0205H67.2963ZM72.8843 23.0205V26.9594H75.3672' +
        'V23.0205H72.8843ZM9.41768 27.2364C9.17159 27.4829 8.79556 ' +
        '28.1726 8.7375 28.5244C8.55501 29.6324 8.58266 33.5658 ' +
        '8.72367 34.7375C8.84257 35.7486 9.86836 36.7928 10.8969 ' +
        '36.9147C12.4646 37.1003 16.7945 37.1031 18.3567 36.9147' +
        'C19.4323 36.7845 20.0544 36.2278 20.4166 35.2444' +
        'C20.9807 33.7099 21.0692 28.3361 19.8056 27.1588' +
        'C18.6222 26.0564 13.825 26.2059 12.1356 26.3251' +
        'C11.237 26.3888 10.0813 26.5771 9.42044 27.2336L9.41768 27.2364' +
        'ZM8.93381 61.5843H5.00206V64.0717H8.93381V61.5843ZM15.3485 ' +
        '61.5843H11.6241V64.0717H15.3485V61.5843ZM21.9705 61.5843' +
        'H18.0388V64.0717H21.9705V61.5843ZM28.5953 61.5843H24.6636' +
        'V64.0717H28.5953V61.5843ZM31.2856 61.5843V64.0717H35.2174' +
        'V61.5843H31.2856ZM4.991 70.2931V72.9994H35.2284V70.2931H4.991Z'
      }
      fill="#00AD00"
    />
    <path
      d={'M18.0388 29.0313V34.4217H11.519C11.4969 34.4217 11.2094 34.1337 ' + '11.2094 34.1115V29.0313H18.0388Z'}
      fill="#00AD00"
    />
  </svg>
);
